import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppConstants } from '../../../app.constant';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Input() defaultLanguage;
  @Input() federaleURL;
  logoPath = 'assets/Logos/logo.svg';
  selectLanguage: boolean;
  selectedLanguage;
  welcome: string;
  languageList = AppConstants.Languages.AllLanguages;
  LogoNL: boolean;
  LogoFR: boolean;

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    
    var currentlang = sessionStorage.getItem("currentlang")
    this.switchLang(currentlang);
    if (currentlang == 'FR') {
     
      this.LogoFR = true;
      this.LogoNL = false;
    }
    else {
      this.LogoFR = false;
      this.LogoNL = true;
    }
  }

  changeLanguage() {

    if (this.translate.currentLang == 'FR') {
      this.defaultLanguage = "NL";
      this.LogoFR = false;
      this.LogoNL = true;
      sessionStorage.setItem("currentlang", "NL")
      sessionStorage.setItem("presentLang", "Even geduld, we zijn uw gegevens aan het laden");
    } else {
      this.LogoFR = true;
      this.LogoNL = false;
      this.defaultLanguage = "FR";
      sessionStorage.setItem("currentlang", "FR")
      sessionStorage.setItem("presentLang", "Veuillez patienter svp, nous chargeons vos données");
    }
    this.switchLang(this.defaultLanguage);

  }

  switchLang(lang: string) {
    this.defaultLanguage = lang;
    if (lang == 'FR') {
      this.LogoFR = true;
      this.LogoNL = false;
    }
    else {
      this.LogoFR = false;
      this.LogoNL = true;
    }
    this.translate.use(lang);

  }

}



